import axios from "axios";

const ENV_URL = process.env.REACT_APP_BACKEND_URL;

// The API is always proxied under /api on the same host that serves the site. When the site is
// opened on a custom domain (e.g. lakemonitor.ai) we must call that same origin, otherwise the
// HttpOnly session cookie would be cross-site and the browser would drop it.
const resolveBackendUrl = () => {
  if (typeof window === "undefined") return ENV_URL;
  const { hostname, origin } = window.location;
  const envHost = (() => { try { return new URL(ENV_URL).hostname; } catch { return ""; } })();
  if (hostname === "localhost" || hostname === envHost) return ENV_URL;
  return origin;
};

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

// Admin session lives in an HttpOnly cookie set by the server; nothing is stored in the browser.
const http = axios.create({ baseURL: API, withCredentials: true });

export const submitLead = async (data) => (await http.post("/leads", data)).data;

export const adminLogin = async (email, password) => (await http.post("/admin/login", { email, password })).data;
export const adminSession = async () => (await http.get("/admin/me")).data;
export const adminLogout = async () => http.post("/admin/logout");

export const fetchLeads = async () => (await http.get("/leads")).data;
export const fetchStats = async () => (await http.get("/leads/stats")).data;

export const updateLeadStatus = async (id, status) => (await http.patch(`/leads/${id}/status`, { status })).data;
export const deleteLead = async (id) => http.delete(`/leads/${id}`);
export const bulkDeleteLeads = async (ids) => (await http.post("/leads/bulk-delete", { ids })).data;
export const changeAdminPassword = async (currentPassword, newPassword) =>
  (await http.post("/admin/change-password", { current_password: currentPassword, new_password: newPassword })).data;
export const addLeadNote = async (id, text, followUpAt) =>
  (await http.post(`/leads/${id}/notes`, { text, follow_up_at: followUpAt || null })).data;
export const setLeadFollowUp = async (id, followUpAt) =>
  (await http.patch(`/leads/${id}/follow-up`, { follow_up_at: followUpAt || null })).data;
export const sendLeadReply = async (id, templateId, note) =>
  (await http.post(`/leads/${id}/reply`, { template_id: templateId, note })).data;

export const sendDigestNow = async () => (await http.post("/admin/digest/send")).data;
export const fetchDigestPreview = async () => (await http.get("/admin/digest/preview")).data;

export const fetchSeoPlan = async () => (await http.get("/admin/docs/seo-plan")).data;
